;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('headerFilter', headerFilter)

  /* @ngInject */
  function headerFilter () {
    return {
      restrict: 'E',
      scope: {
        submit: '&'
      },
      replace: true,
      templateUrl: '/core/directives/header-filter/header-filter-directive.html?$$REVISION$$',
      controller: 'HeaderFilterController'
    }
  }
})()
